import React from 'react';
import './style.scss';
import { Modal } from 'react-bootstrap';
import Button from '../../../molecules/buttons';
import useModalDefault from './hooks';

interface Props {
  cancelLabel: string;
  submitLabel: string;
  title: string;
  body: string | React.ReactElement;
  onSubmit?: () => any;
  onSubmitClose?: () => any;
  onAfterResult?: () => any;
  children?: React.ReactElement;
  size?: 'sm' | 'lg' | 'xl' | undefined;
  centered?: boolean;
  dialogClassName?: string;
  isLoading?: boolean;
  result?: string;
  closeButton?: boolean;
  onInit?: () => void;
  isConfirmDisabled?: boolean;
  autoShow?: boolean;
}

const Default: React.FC<Props> = (props) => {
  const {
    submitLabel, cancelLabel, title, body,
    onSubmit, onSubmitClose, children, size, centered, dialogClassName,
    isLoading, result, closeButton, isConfirmDisabled = false, autoShow = false,
    onAfterResult = () => null,
    onInit = () => null,
  } = props;
  const { show, handleClose, handleShow } = useModalDefault(onInit, autoShow);

  return (
    <div>
      {!autoShow
        ? (
          <button type="button" onClick={handleShow} className="border-0 bg-transparent w-100">
            {children}
          </button>
        )
        : ('')}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size={size}
        centered={centered}
        dialogClassName={dialogClassName}
      >
        <Modal.Header className="border-0 pb-0" closeButton={closeButton}>
          <Modal.Title>
            <h2 className="m-0 p-0">{title}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="color-secondary fw-normal">{body}</h6>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          {!result
            ? (
              <div className="d-flex justify-content-end">
                <div className="me-2">
                  <Button.Default
                    id="cancelModal"
                    type="button"
                    outline
                    size="sm"
                    label={cancelLabel}
                    onClick={handleClose}
                    className="px-4 fz-14"
                  />
                </div>
                <Button.Default
                  id="acceptModal"
                  type="button"
                  size="sm"
                  style={isConfirmDisabled ? {
                    background: 'gray',
                    borderColor: 'gray',
                  } : {}}
                  label={submitLabel}
                  onClick={() => {
                    if (onSubmitClose) {
                      onSubmitClose();
                      handleClose();
                    } else if (onSubmit) {
                      onSubmit();
                    } else {
                      handleClose();
                    }
                  }}
                  loading={isLoading}
                  className="px-4 fz-14"
                  disabled={isConfirmDisabled}
                />
              </div>
            ) : (
              <Button.Default
                id="acceptModal"
                type="button"
                size="sm"
                label="Close"
                onClick={() => {
                  handleClose();
                  onAfterResult();
                }}
                className="px-4 fz-14"
              />
            )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default React.memo(Default);
